import { reflect } from '@effector/reflect';
import { Switch } from '@mantine/core';
import { translated } from 'shared/lib';
import { shiftsPageModel } from '../../model';
import cls from './shifts-page-contribution.module.scss';

export const ShiftPageContribution = reflect({
	view: Switch,
	bind: {
		label: translated('shifts-page.my-contribution'),
		className: cls.shiftsPageContribution,
		checked: shiftsPageModel.isPersonal.$value,
		onChange: (e) => shiftsPageModel.isPersonal.setValue(e.currentTarget.checked),
	},
});
